export const vehicle = {
  editFleet: "编辑车间",
  editVehicle: "编辑设备",
  failedToAddAuthorizedDrivers:
    "添加授权司机失败。请刷新页面以获得最新的司机列表。",
  failedToSaveFleetNameAlreadyExist: "保存失败，此车间名已占用。",
  failedToSaveVehicleIDAlreadyExist: "保存失败，此设备已存在。",
  FailedToSyncWithCloud: "无法同步系统设置。",
  failedToUnbindDevice: "未能从设备解除已注册的系统。",
  fleetDeleteTip: "车间{0}将被删除。确定要继续吗？",
  fleetDetails: "车间详情",
  fleetNameOrVehicleID: "车间名称或设备编号",
  newFleet: "新建车间",
  newVehicle: "新建设备",
  pleaseInputDutyDayOfWeek: "请勾选该车间的工作日",
  pleaseInputFleetName: "请输入车间名称",
  pleaseInputVehicleID: "请输入设备编号",
  pleaseSelectFleet: "请选择车间",
  pleaseSelectVehicleModel: "请选择设备型号或新建",
  pleaseSelectWiFiMode: "请选择Wi-Fi模式",
  syncedWithCloud: "同步系统设置成功。",
  syncWithCloud: "同步系统设置",
  unbindDeviceSuccessfully: "此设备上的系统已注销。",
  unbindTip: "如果注销设备上的系统，将不再发送数据到云端。",
  unregister: "注销",
  vehicleDeleteTip: "设备{0}将被删除。确定要继续吗？",
  vehicleDetails: "设备详情",
  vehicleInformation: "设备信息",
  pleaseInputWorkingHours: "请选择该车间的工作时间",
  invalidWorkingHours: "工作时间无效",
  nextVehicleCheckTime: "车检有效期至",
  nextMaintenanceTime: "下一次保养日期",
  pleaseInputNextMaintenanceTime: "请输入下一次保养日期",
  failedToDeleteMaintenanceNotDone:
    "删除失败，{vehicle} 的维修单/保养单尚未结案。",
  failedToDeleteBindDevice: "删除失败，{vehicle} 已注册设备，请注销后重试。",
  pleaseInputSpeedLimit: "请输入限速值",
  pleaseInputTireDimension: "请输入轮径值",
  pleasePickFleet: "请选择一个车间",
  pleaseInputNextCheckTime: "请输入车检有效期",
  failedToEditVehicleFleet:
    "修改设备车间信息失败。此设备的维修单/保养单尚未结案。",
};
